const LANGUAGE_COOKIE = 'NEXT_LOCALE';

export default LANGUAGE_COOKIE;
